const DEFAULT_LIFF_ID = process.env.REACT_APP_LINEID || "";
const OA_MAP_RAW = process.env.REACT_APP_LINE_OA_MAP || "";
const RUNTIME_LIFF_ID_CACHE_KEY = "runtimeLiffId";

const parseOaMap = (raw: string): Record<string, string> => {
  return raw
    .split(",")
    .map((item) => item.trim())
    .filter(Boolean)
    .reduce<Record<string, string>>((acc, item) => {
      const [oaKey, liffId] = item.split(":").map((part) => part.trim());
      if (!oaKey || !liffId) return acc;
      acc[oaKey] = liffId;
      return acc;
    }, {});
};

const OA_LIFF_ID_MAP = parseOaMap(OA_MAP_RAW);

const saveRuntimeLiffId = (liffId: string) => {
  if (!liffId || typeof window === "undefined") return;
  sessionStorage.setItem(RUNTIME_LIFF_ID_CACHE_KEY, liffId);
};

export const getRuntimeLiffId = (): string => {
  if (typeof window === "undefined") return DEFAULT_LIFF_ID;

  const searchParams = new URLSearchParams(window.location.search);
  const liffIdFromQuery = (searchParams.get("liffId") || "").trim();
  if (liffIdFromQuery) {
    saveRuntimeLiffId(liffIdFromQuery);
    return liffIdFromQuery;
  }

  const oa = (searchParams.get("oa") || "").trim();
  if (oa && OA_LIFF_ID_MAP[oa]) {
    const mappedLiffId = OA_LIFF_ID_MAP[oa];
    saveRuntimeLiffId(mappedLiffId);
    return mappedLiffId;
  }

  const cachedLiffId = sessionStorage.getItem(RUNTIME_LIFF_ID_CACHE_KEY);
  if (cachedLiffId) return cachedLiffId;

  saveRuntimeLiffId(DEFAULT_LIFF_ID);
  return DEFAULT_LIFF_ID;
};

export const getLiffAccessTokenStorageKey = () => {
  const liffId = getRuntimeLiffId();
  return `LIFF_STORE:${liffId}:accessToken`;
};
